import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {InternalDocument} from "./internal-documents.component";
import {EndpointsProvider} from "../../endpoints/endpoint-provider.service";

@Injectable()
export class InternalDocumentsService {

	constructor(private endpoints: EndpointsProvider) {
	}

	fetchInternalDocumentEntries(correlationId: string): Observable<InternalDocument[]> {
		return this.endpoints.documents.getInternalDocumentsMetadata(correlationId);
	}

	uploadInternalDocument(correlationId: string, file: File): Observable<InternalDocument[]> {
		return this.endpoints.documents.uploadInternalDocument(correlationId, file);
	}


	deleteInternalDocument(correlationId: string, fileUuid: string): Observable<InternalDocument[]> {
		return this.endpoints.documents.deleteInternalDocument(correlationId, fileUuid);
	}

}
